import * as React from 'react';

import {CardWidgetEmptyState} from 'shells/empty-states/card-widget-empty-state';
// @ts-expect-error
import {EmailIcon} from 'shells/icon/svg/email-icon';
import {EmailSequenceProgression} from 'shells/sequence-progression/email-sequence-progression';
import type {EmailSequence} from 'shells/sequence-progression/email-sequence-progression';
import {SectionLabel} from 'shells/typography/section-label';

type Props = {
    emailSequences: EmailSequence[];
    entityType: 'company' | 'lead' | 'person';
    showPreviewModal: (arg1: string, arg2: string) => void;
    onCancelSequenceProgression: (arg1: string) => Promise<any>;
};

export function DripSequences(props: Props) {
    const {emailSequences, entityType, showPreviewModal, onCancelSequenceProgression} = props;

    const hasContent = emailSequences.length > 0;

    return (
        <div className='mb-24'>
            {hasContent ? (
                <EmailSequenceProgression
                    label='Drip sequences'
                    isDripSequence={true}
                    emailSequences={emailSequences}
                    entityType={entityType}
                    showPreviewModal={showPreviewModal}
                    onCancelSequenceProgression={onCancelSequenceProgression}
                />
            ) : (
                <div className='flex flex-dir-col'>
                    <SectionLabel noBottomMargin={hasContent} noBottomBorder={hasContent}>
                        Drip sequences
                    </SectionLabel>
                    <div className='mt-16'>
                        <CardWidgetEmptyState
                            icon={EmailIcon}
                            text='No drip sequences have been set for this lead’s stage'
                            isHorizontal={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
